import { render, staticRenderFns } from "./JdsPageSection.vue?vue&type=template&id=1881ffb4&scoped=true&"
import script from "./JdsPageSection.vue?vue&type=script&lang=ts&"
export * from "./JdsPageSection.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPageSection.vue?vue&type=style&index=0&id=1881ffb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881ffb4",
  null
  
)

export default component.exports